// extracted by mini-css-extract-plugin
module.exports = {"wholeContainer":"CustomSpinner_wholeContainer__2toDX","spinnerFullScreen":"CustomSpinner_spinnerFullScreen__ghyNL","loadingSpinner":"CustomSpinner_loadingSpinner__2TGT0"};